module.exports = __webpack_public_path__ + "img/thumb_sweet_potato.458baff7.jpg";